export const REFERRAL_TYPES = {
  ACTIVE: 'active',
  SPECIAL: 'special',
  FF: 'ff',
};

export const REFERRAL_TYPE_LABELS = {
  [REFERRAL_TYPES.ACTIVE]: 'Referral Active',
  [REFERRAL_TYPES.SPECIAL]: 'Referral Special',
  [REFERRAL_TYPES.FF]: 'Referral F&F',
};

export const REFERRAL_TYPE_DESCRIPTIONS = {
  [REFERRAL_TYPES.ACTIVE]: 'Referral coming from activated customer ONLY',
  [REFERRAL_TYPES.SPECIAL]: 'Referral coming from MATA & MCTA ONLY',
  [REFERRAL_TYPES.FF]: 'Referral coming from Farmer’s Friends and Family ONLY',
};

export const REFERRAL_TYPE_OPTIONS = [
  {
    value: REFERRAL_TYPES.ACTIVE,
    label: REFERRAL_TYPE_LABELS[REFERRAL_TYPES.ACTIVE],
    description: REFERRAL_TYPE_DESCRIPTIONS[REFERRAL_TYPES.ACTIVE]
  },
  {
    value: REFERRAL_TYPES.SPECIAL,
    label: REFERRAL_TYPE_LABELS[REFERRAL_TYPES.SPECIAL],
    description: REFERRAL_TYPE_DESCRIPTIONS[REFERRAL_TYPES.SPECIAL]
  },
  {
    value: REFERRAL_TYPES.FF,
    label: REFERRAL_TYPE_LABELS[REFERRAL_TYPES.FF],
    description: REFERRAL_TYPE_DESCRIPTIONS[REFERRAL_TYPES.FF]
  },
];
